import { SVGProps, useId } from "react";
export const TelegramJetIcon = (props: SVGProps<SVGSVGElement>) => {
  const generateId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={22}
      fill="none"
      viewBox="0 0 24 22"
      {...props}
    >
      <path
        fill={`url(#${generateId})`}
        d="M23.366.412A1.767 1.767 0 0 0 21.569.13L1.093 8.465c-.33.138-.612.373-.808.675a1.789 1.789 0 0 0 .055 2.02c.21.29.505.51.842.629l4.419 1.546 2.394 7.982c.004.016.02.026.026.041a.56.56 0 0 0 .365.338c.011.004.019.015.03.017h.007l.004.001c.088.02.18.015.266-.014.01-.002.018-.002.029-.005a.565.565 0 0 0 .218-.141c.007-.008.018-.01.025-.016l3.443-3.833 5.025 3.924c.306.24.682.371 1.069.371.839 0 1.562-.592 1.735-1.419l3.728-18.458A1.78 1.78 0 0 0 23.366.41M9.244 14.85l-.808 3.961-1.686-5.62L15.11 8.8 9.4 14.56a.575.575 0 0 0-.156.29Zm9.873 5.5a.624.624 0 0 1-.702.493.597.597 0 0 1-.282-.123l-5.443-4.251a.568.568 0 0 0-.773.069L9.52 19.2l.807-3.95 8.216-8.285a.578.578 0 0 0-.274-.968.567.567 0 0 0-.393.05l-11.844 6.22-4.476-1.57a.601.601 0 0 1-.413-.566.617.617 0 0 1 .382-.597L21.998 1.2a.608.608 0 0 1 .638.099.603.603 0 0 1 .208.597L19.117 20.35Z"
      />
      <defs>
        <linearGradient
          id={generateId}
          x1={-0.493}
          x2={10.752}
          y1={11}
          y2={-1.206}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="var(--start-color, #0BADC2)" />
          <stop offset={1} stopColor="var(--end-color, #0AA5BE)" />
        </linearGradient>
      </defs>
    </svg>
  );
};
